import classNames from 'classnames'
import { memo } from 'react'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import getRandomAd from '@/utils/getRandomAd'

import styles from './Sidebar.module.scss'

type Props = {
  country?: string
}

const Sidebar = ({ country }: Props) => {
  if (country === 'MX') {
    const randomAd = getRandomAd('tcg.land/sidebar')
    return (
      <div className={styles.sidebar}>
        <OutboundLink url='https://tcg.land/?utm_source=edhrec&utm_medium=sidebar' utm_medium='sidebar'>
          <img alt='TCG.Land' className={styles.tcgland} src={randomAd.src} />
        </OutboundLink>
      </div>
    )
  }

  return <div className={classNames(styles.sidebar, 'mvSidebar1')} />
}

export default memo(Sidebar)
